export const titleAddDebounceTime = 300;

export const titleEditDebounceTime = 300;

export const subDomainDebounceTime = 100;

export const titleSlugCategoryDebounceTime = 300;

export const toastTimeoutTime = 10000;

export const articleSearchDebounceTime = 200;
